export const data: { question: string; answer: JSX.Element }[] = [
  {
    question: 'Does this only work for clinical (diagnosed) ADHD?',
    answer: (
      <div>
        <p>
          {`No, Brain.fm isn't limited to people with a clinical ADHD diagnosis. While Brain.fm 
          does cater to people with attention difficulties, including ADHD, its music is designed for 
          anyone seeking to improve focus, relaxation, or sleep. The technology behind Brain.fm uses specific audio 
          frequencies and rhythms to help your brain enter a particular state, like focus or relaxation, 
          so it can be beneficial even for those without a formal ADHD diagnosis.`}
        </p>
        <p>
          Many users without ADHD find it helpful for tasks that require sustained concentration, reducing distractions, or managing anxiety and stress.
        </p>
      </div>
    ),
  },
  {
    question: 'Is Brain.fm a treatment or cure for ADHD?',
    answer: (
      <div>
        <p>
          {`No. Brain.fm is a management tool that supports attention while you’re using it. 
          Similar to fidget toys, fidget spinners, or time-management tools like pomodoro timers, 
          Brain.fm isn’t intended to permanently solve attentional problems, but instead 
          to help you during tasks that require focus.`}
        </p>
      </div>
    ),
  },
  {
    question: 'Can I use Brain.fm with other stimulants?',
    answer: (
      <div>
        <p>
          {`Yes. Brain.fm is not medication and thus carries no risk of pharmacological interactions.
           Many of our users pair Brain.fm with coffee, and our users with clinical ADHD pair Brain.fm 
           with their usual stimulant medications. `}
        </p>
      </div>
    ),
  },
];
